/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface ActionContainerProps {
  form: ReactNode;
}

const useStyles = makeStyles(() => ({
  rightContainer : {
    overflowY  : 'scroll',
    flex       : 3,
    background : dlsColor('grey5')
  }
}));

/**
 * This step will display the page containing a preview panel showing action detail forms.
 */
export const ActionContainer = ({
  form
}: ActionContainerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.rightContainer}>
      {form}
    </div>
  );
};

export default ActionContainer;
